import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_CONNECTIONS,
    RESPOND_ADD_CONNECTION,
    RESPOND_UPDATE_CONNECTION,
    RESPOND_REMOVE_CONNECTION,
    RESPOND_SYNC_CONNECTION,
    RESPOND_SYNC_ALL_CONNECTIONS,
    RESPOND_LIST_CAMERAS,
    RESPOND_SYNC_SELECTED_CAMERAS,
    RESPOND_UPDATE_APP_ID,
    RESPOND_GET_APP_ID,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/genetecMsgDefinitions";
import {
    GenetecPassport,
    GenetecPassportHeader,
    GenetecPassportID,
    GenetecCameraList,
    GenetecAppIdPayload,
} from "userful-chronos-app-common-js/dist/models/integration/genetec";
import integrationStore from "../integrationStore";
import { genetecActions } from "../genetecSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_CONNECTIONS, (payload) => {
    const data = JSON.parse(payload) as GenetecPassport[];
    integrationStore.dispatch(genetecActions.setPassports(data));
});

registerMsgHandler(RESPOND_ADD_CONNECTION, (payload) => {
    JSON.parse(payload) as GenetecPassportHeader;
    integrationStore.dispatch(genetecActions.changeLoadState("RENDER"));
    integrationStore.dispatch(genetecActions.setOpenForm(false));
    integrationStore.dispatch(genetecActions.getPassportsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_CONNECTION, () => {
    integrationStore.dispatch(genetecActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_CONNECTION, (payload) => {
    JSON.parse(payload) as GenetecPassportHeader;
    integrationStore.dispatch(genetecActions.changeLoadState("RENDER"));
    integrationStore.dispatch(genetecActions.setOpenForm(false));
    integrationStore.dispatch(genetecActions.getPassportsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_CONNECTION, () => {
    integrationStore.dispatch(genetecActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_CONNECTION, (payload) => {
    const data = JSON.parse(payload) as GenetecPassportID;
    integrationStore.dispatch(genetecActions.removePassport(data));
});

registerMsgHandler(RESPOND_SYNC_CONNECTION, () => {
    integrationStore.dispatch(genetecActions.getPassportsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_SYNC_CONNECTION, () => {
    integrationStore.dispatch(genetecActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_SYNC_ALL_CONNECTIONS, () => {
    integrationStore.dispatch(genetecActions.getPassportsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_SYNC_ALL_CONNECTIONS, () => {
    integrationStore.dispatch(genetecActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_LIST_CAMERAS, (payload) => {
    const data = JSON.parse(payload) as GenetecCameraList;
    integrationStore.dispatch(genetecActions.setCameras(data));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_LIST_CAMERAS, () => {
    integrationStore.dispatch(genetecActions.setCamerasLoadState({ state: "ERROR" }));
});

registerMsgHandler(RESPOND_SYNC_SELECTED_CAMERAS, () => {
    integrationStore.dispatch(genetecActions.setCameraSyncState("RENDER"));
    integrationStore.dispatch(genetecActions.getPassportsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_SYNC_SELECTED_CAMERAS, () => {
    integrationStore.dispatch(genetecActions.setCameraSyncState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_APP_ID, (payload) => {
    const data = JSON.parse(payload) as GenetecAppIdPayload;
    integrationStore.dispatch(genetecActions.setAppId({ ...data, source: "SAVE" }));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_APP_ID, () => {
    integrationStore.dispatch(genetecActions.setAppIdError("SAVE"));
});

registerMsgHandler(RESPOND_GET_APP_ID, (payload) => {
    const data = JSON.parse(payload) as GenetecAppIdPayload;
    integrationStore.dispatch(genetecActions.setAppId({ ...data, source: "FETCH" }));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_GET_APP_ID, () => {
    integrationStore.dispatch(genetecActions.setAppIdError("FETCH"));
});
